// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {type FC, memo, useCallback, useContext, useState} from 'react';

import {CreateTeamDrawer} from '../../../pages/HomePage/HomePageSidebar/CreateTeamDrawer';
import {trackNavRightFeatureOpened} from '../../../services/analytics/productEvents';
import {
  useIsAdminModeActiveAndIsNotLocalEnv,
  viewingAs,
} from '../../../util/admin';
import {useNavContext} from '../../NavContextProvider';
import {AccountSelectorContext} from './AccountSelectorContextProvider';

const InviteTeammatesButtonComp: FC = () => {
  const {isCreatingTeam} = useNavContext();
  const [isCreatingTeamInvite, setIsCreatingTeamInvite] = useState(false);
  const {selectedAccount} = useContext(AccountSelectorContext);
  const isAdminMode =
    useIsAdminModeActiveAndIsNotLocalEnv() || viewingAs() !== '';

  const toggleTeamInviteDrawer = useCallback(() => {
    if (!isCreatingTeamInvite) {
      trackNavRightFeatureOpened({
        feature: 'invite_teammates',
        selected_account: selectedAccount,
        is_admin_mode: isAdminMode,
      });
    }
    setIsCreatingTeamInvite(!isCreatingTeamInvite);
  }, [isCreatingTeamInvite, selectedAccount, isAdminMode]);

  return (
    <>
      <Button
        icon="users-team"
        className="hidden sm:flex"
        twWrapperStyles={{
          marginRight: '7px',
          marginLeft: '7px',
        }}
        size="large"
        disabled={isCreatingTeam}
        onClick={toggleTeamInviteDrawer}>
        Invite teammates
      </Button>
      <CreateTeamDrawer
        open={isCreatingTeamInvite}
        toggleTeamDrawer={toggleTeamInviteDrawer}
        analyticsLocation="top nav bar"
      />
    </>
  );
};

const InviteTeammatesButton = memo(InviteTeammatesButtonComp);
InviteTeammatesButton.displayName = 'InviteTeammatesButton';

export default InviteTeammatesButton;
